
import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

import HistorySlider from "./HistorySlider";
import LatestNewevent from "./LatestNewEvent"
function News() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/slider-1.jpg)',backgroundSize:'cover',backgroundPosition:'top'}}></div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">


          <div style={{height:'600px',marginTop:'90px'}}>
              <h3>No News and Events</h3>
            </div>

            {/* <LatestNewevent /> */}





            <div style={{ padding: '60px' }}>
              <h3 className="historyheadeg">{t("history_h1")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h1_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h2")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h2_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h3")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h3_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h4")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h4_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h5")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h5_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h6")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h6_para")}
              </p>
              <ol className="hcontent" style={{ marginLeft: '25px' }}>
                <li>{t("1")}</li>
                <li>{t("2")}</li>
                <li>{t("3")}</li>
              </ol>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h6_2_para")}
              </p>

            </div>

          </div>
          

        </div>
      </div>
    </div>
  );
}

export default News;
